import { useNavigate } from "react-router-dom";
import HelperProducts from "../../common/HelperProducts";
import CheckboxSwitch from "../../components/CheckboxSwitchComponent/CheckboxSwitch";
import { i18n } from "../../lang/i18n";
import { actCartProductQuantityChange } from "../../store/Actions";
import { reducerCartClear, reducerCartRitmitoUpdate } from '../../store/Cart/CartReducer';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

interface Props {
    isReady: boolean,
    onStepContinue: () => void
}

export default function DeliveryStepProducts(props: Props) {
    const dispatch = useAppDispatch()
    const cart = useAppSelector((state) => state.cart)
    const userData = useAppSelector((state) => state.userData)
    const productExtras = useAppSelector((state) => state.appData.productExtras)
    const navigate = useNavigate();
    const ritmitosAvailable = userData.loyalty.ritmitosAvailable - (userData.loyalty.ritmitosInOrders ? userData.loyalty.ritmitosInOrders : 0)


    function cartToList(data: any) {
        let items = [];
        for (let f in data) {
            items.push(data[f]);
        }
        return items;
    }
    function onItemChange(index: number, value: number) {
        if (value === -1 && cart.products.length === 1 && cart.products[0].quantity === 1)
            navigate('/')
        actCartProductQuantityChange(dispatch,index, value)
    }

    function onClearClick(e: any) {
        e.preventDefault();
        dispatch(reducerCartClear());
        navigate('/')
    }

    const products = cartToList(cart.products);

    if (props.isReady)
        return <div className="row p-3">
            <div className="col">
                <b>{cart.products.length}</b> {i18n.Home.Products} <b>{cart.totalPrice.toFixed(2)} €</b> {i18n.Home.TotalPrice}
            </div>
        </div>
    return <div>
        {ritmitosAvailable > 0 && <div style={{ color: 'black' }} className="text-center pt-2">
            <h5>{i18n.TabCart.YouHave} {ritmitosAvailable}⚡</h5>
            <CheckboxSwitch conf={{ active: cart.useRitmitos, textActive: i18n.TabCart.RitmitosUse, textDeactivate: i18n.TabCart.RitmitosNotUse, fieldName: '' }}
                style={{ display: 'inline' }}
                onChange={(e: any, conf: any) => {
                    dispatch(reducerCartRitmitoUpdate({ useRitmitos: conf.active, ritmitosAvailable: ritmitosAvailable }))
                    return true;
                }}
            />
        </div>}

        <table className="table">
            <thead>
                <tr>
                    <td>#</td>
                    <td></td>
                    <td>{i18n.TabCart.ListQuantity}</td>
                    <td>€</td>
                </tr>
            </thead>
            <tbody>
                {products.map((item, index) => (
                    <tr key={index}>
                        <td className="step-number">{index + 1}</td>
                        <td>{HelperProducts.ProductDescription(productExtras, item)}</td>
                        <td className="size-buttons">
                            <div className="text-center"><label
                                className="size-quantity">{item.quantity}</label>
                            </div>
                            <div className="text-center" style={{ minWidth: '80px' }}>
                                <button type="button" className="btn btn-success btn-sm mr-1" data-action="minus"
                                    data-code={item.key}
                                    onClick={() => onItemChange(index, -1)}><i
                                        className="fa fa-minus" /></button>

                                <button type="button" className="btn btn-success btn-sm" data-action="plus"
                                    data-code={item.key}
                                    onClick={() => onItemChange(index, 1)}><i className="fa fa-plus" />
                                </button>
                            </div>
                        </td>
                        <td>{item.price.toFixed(2)}</td>
                    </tr>
                ))}
                {cart.transportPrice.active && <tr>
                    {cart.transportPrice.price > 0 && <td colSpan={4} className="text-right">{i18n._Labels.Transport}: {cart.transportPrice.price} €</td>}
                    {cart.transportPrice.price === 0 && <td colSpan={4} className="text-right">{i18n._Labels.Transport}: {i18n._Labels.Free}</td>}
                </tr>}
                <tr>
                    <td colSpan={4} className="text-right">{i18n.TabCart.ListTotal}: {cart.totalPrice.toFixed ? cart.totalPrice.toFixed(2) : cart.totalPrice} €</td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <button type="button" className="btn btn-outline-secondary btn-sm"
                            onClick={onClearClick}>
                            <i className="fa fa-trash-alt" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div className="box p-3 text-center">
            <button className="btn btn-warning" style={{ minWidth: 250 }}
                onClick={props.onStepContinue}>{i18n._BTNs.Continue}
            </button>
        </div>
    </div>
}